export const PARTNERS = {
  // mapped by agent ID
  ajLGIkQP4jBqqNfe0hPT: {
    id: "isure",
    name: "isure",
    tokenParam: "isure_jwt",
  },
};

export const getPartnerConfig = (source, medium) => {
  if (source === "agentes" && medium) {
    return PARTNERS[medium] || null;
  }
  return null;
};
